// extracted by mini-css-extract-plugin
export default {"quickResponseContainer":"styles__quickResponseContainer___WtIF8","textAndIconContainer":"styles__textAndIconContainer___nUAlx"};